import { useState } from "react"; // これを追加！
const Midashi = (props) => {
  console.log(props); // これを追加！コンソールに {midashi: "今日の掘り出し物アイテム"} という塊が3回表示されるはずです。これを見ると「ああ、これが props という塊なんだ！」と一発で理解できると思います。
  return (
    <div>
      <h3>【見出し】{props.midashi}</h3>
    </div>
  );
};
export default Midashi;
